import React, { useState, useEffect } from "react";
import Logo from "../../assets/company-logo/Logo1.png";
import { NavLink, Link } from "react-router-dom";
import ResponsiveMenu from "./ResponsiveMenu";
// import './index.css'; // Ensure this is imported
import { HiMenuAlt3, HiMenuAlt1 } from "react-icons/hi";
// import "./Navbar.css"; // Import the new CSS file for Valentine's Day theme

export const NavbarLinks = [
  {
    name: "Home",
    link: "/",
  },
  {
    name: "Itinerary",
    link: "/products",
  },
  {
    name: "Blogs",
    link: "/blogsdetails",
  },
  {
    name: "Hotels",
    link: "/Hotels",
  },
  {
    name: "flights",
    link: "/flights",
  },
  {
    name: "Visa",
    link: "/visa",
  },
  {
    name: "Contact Us",
    link: "/contact-us",
  },
  {
    name: "About Us",
    link: "/about",
  },
];


const Navbar = ({ handleOrderPopup }) => {
  const [showMenu, setShowMenu] = useState(false);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  return (
    <>
      <nav className="fixed xl:px-32 px-0 dark:bg-black customColor items-center justify-center bg-opacity-40 top-0 right-0 w-full z-50 backdrop-blur-sm text-white shadow-md">
        <div className="container md:py-0">
          <div className="flex justify-between md:justify-center items-center">
            <div className="pl-3">
              <Link to={"/"} onClick={() => window.scrollTo(0, 0)}>
                <img src={Logo} alt="TripDekhoo Logo" className="w-32 h-auto" />
              </Link>
            </div>
            <div className="hidden font-bold md:flex justify-center xl:justify-end w-full">
              <ul className="flex items-center gap-8">
                {NavbarLinks.map((link) => (
                  <li key={link.name} className="py-4">
                    <NavLink to={link.link} activeClassName="active">
                      {link.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
            <div className="flex items-center gap-4">
              <div className="md:hidden block">
                {showMenu ? (
                  <HiMenuAlt1
                    onClick={toggleMenu}
                    className="cursor-pointer transition-all"
                    size={30}
                  />
                ) : (
                  <HiMenuAlt3
                    onClick={toggleMenu}
                    className="cursor-pointer transition-all"
                    size={30}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <ResponsiveMenu setShowMenu={setShowMenu} showMenu={showMenu} />
      </nav>
    </>
  );
};

export default Navbar;
